import React from "react";
import InnerLayout, { disclosureSidebar } from "../InnerLayout";

const governanceBodies = [
  {
    title: "Governing Council",
    description:
      "Provides strategic direction and oversees institutional development, policy implementation and long-term planning.",
  },
  {
    title: "Academic Council",
    description:
      "Monitors academic quality, curriculum implementation, teaching-learning processes and student progression.",
  },
  {
    title: "Finance Committee",
    description:
      "Reviews financial planning, budgeting, resource allocation and institutional expenditure.",
  },
  {
    title: "Internal Quality Assurance Cell (IQAC)",
    description:
      "Promotes continuous quality improvement and institutional excellence through quality assurance initiatives.",
  },
];

const policies = [
  "Anti-Ragging Policy",
  "Grievance Redressal Policy",
  "Research & Innovation Policy",
  "Gender Sensitization Policy",
  "Code of Conduct",
  "Environmental Sustainability Policy",
];

const governanceDocuments = [
  {
    title: "VDIT Code of Conduct",
    file: "/GOVERANCE/VDIT-Code-of-Conduct.pdf",
  },
  {
    title: "Audit Report VDIT 2023-24",
    file: "/GOVERANCE/Audit-Report-VDIT-2023-24_compressed.pdf",
  },
  {
    title: "Audit Report VDIT 2024-25",
    file: "/GOVERANCE/Audit-Report-VDIT-2024-25_compressed.pdf",
  },
];

const committees = [
  {
    title: "Anti-Ragging Committee",
    file: "/Governance_commities/Anti-Ragging-committee.pdf",
  },
  {
    title: "Internal Complaints Committee",
    file: "/Governance_commities/Internal-Complaints-Committee.pdf",
  },
  {
    title: "Caste Discrimination Committee",
    file: "/Governance_commities/Caste-Discrimination-Committee.pdf",
  },
  {
    title: "Grievance Committee",
    file: "/Governance_commities/GRIEVANCE-committee.pdf",
  },
  // {
  //   title: "Training & Placement Cell",
  //   file: "/GOVERANCE/Training-Placement-Cell.pdf",
  // },
  // {
  //   title: "Research & Development Cell",
  //   file: "/GOVERANCE/Research-Development-Cell.pdf",
  // },
];

const Governance = () => {
  return (
    <InnerLayout
      title="Institutional Governance"
      image="https://images.pexels.com/photos/12091126/pexels-photo-12091126.jpeg?w=2400"
      breadcrumbs={[
        { label: "Disclosure", to: "/disclosure" },
        { label: "Governance" },
      ]}
      sidebar={disclosureSidebar}
      sidebarTitle="Disclosure"
    >
      {/* ABOUT */}
      <section className="mb-14">
        <h2
          className="text-3xl md:text-4xl text-brand mb-6 font-semibold"
          style={{ fontFamily: "'Cormorant Garamond', serif" }}
        >
          Governance at KLS VDIT
        </h2>

        <div className="vdit-prose">
          <p>
            KLS Vishwanathrao Deshpande Institute of Technology follows a
            transparent, participative and accountable governance system
            that supports academic excellence, innovation and institutional
            growth.
          </p>

          <p>
            The governance framework includes management representatives,
            academic leaders, faculty members, industry experts, alumni and
            stakeholders who collectively contribute to institutional
            decision-making and quality enhancement.
          </p>
        </div>
      </section>

      {/* GOVERNANCE STRUCTURE */}
      <section className="mb-14">
        <h2
          className="text-3xl md:text-4xl text-brand mb-6 font-semibold"
          style={{ fontFamily: "'Cormorant Garamond', serif" }}
        >
          Governance Structure
        </h2>

        <div className="grid md:grid-cols-2 gap-6">
          {governanceBodies.map((item) => (
            <div
              key={item.title}
              className="bg-white border border-brand/10 p-6"
            >
              <h3 className="text-xl text-brand font-semibold mb-3">
                {item.title}
              </h3>

              <p className="text-[#2a2a2a]/85">
                {item.description}
              </p>
            </div>
          ))}
        </div>
      </section>

      <section>
        <h2
          className="text-3xl md:text-4xl text-brand mb-6 font-semibold"
          style={{ fontFamily: "'Cormorant Garamond', serif" }}
        >
          Governance Documents
        </h2>

        <div className="overflow-hidden border border-brand/10">
          <table className="w-full">
            <thead>
              <tr className="bg-brand text-white">
                <th className="px-5 py-4 text-left">Sl. No.</th>
                <th className="px-5 py-4 text-left">Document</th>
                <th className="px-5 py-4 text-left">Download</th>
              </tr>
            </thead>

            <tbody>
              {governanceDocuments.map((doc, index) => (
                <tr
                  key={doc.title}
                  className={index % 2 === 0 ? "bg-white" : "bg-surface-alt/40"}
                >
                  <td className="px-5 py-4">{index + 1}</td>
                  <td className="px-5 py-4">{doc.title}</td>
                  <td className="px-5 py-4">
                    <a
                      href={doc.file}
                      target="_blank"
                      rel="noreferrer"
                      className="text-brand font-semibold hover:underline"
                    >
                      Download PDF
                    </a>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <p className="text-sm text-[#3a3a3a]/70 mt-4">
          * Detailed governance policies and committee documents are updated
          periodically.
        </p>
      </section>

      {/* COMMITTEES */}
     <section className="mb-14">
  <h2
    className="text-3xl md:text-4xl text-brand mb-6 font-semibold"
    style={{ fontFamily: "'Cormorant Garamond', serif" }}
  >
    Institutional Committees
  </h2>

  <div className="overflow-hidden border border-brand/10">
    <table className="w-full">
      <thead>
        <tr className="bg-brand text-white">
          <th className="px-5 py-4 text-left">Sl. No.</th>
          <th className="px-5 py-4 text-left">Committee</th>
          <th className="px-5 py-4 text-left">Download</th>
        </tr>
      </thead>

      <tbody>
        {committees.map((committee, index) => (
          <tr
            key={committee.title}
            className={
              index % 2 === 0
                ? "bg-white"
                : "bg-surface-alt/40"
            }
          >
            <td className="px-5 py-4">{index + 1}</td>

            <td className="px-5 py-4">
              {committee.title}
            </td>

            <td className="px-5 py-4">
              <a
                href={committee.file}
                target="_blank"
                rel="noreferrer"
                className="text-brand font-semibold hover:underline"
              >
                Download PDF
              </a>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  </div>
</section>

      {/* POLICIES */}
      {/* <section>
        <h2
          className="text-3xl md:text-4xl text-brand mb-6 font-semibold"
          style={{ fontFamily: "'Cormorant Garamond', serif" }}
        >
          Institutional Policies
        </h2>

        <div className="grid md:grid-cols-2 gap-4">
          {policies.map((policy) => (
            <div
              key={policy}
              className="bg-white border border-brand/10 p-5"
            >
              <p className="text-[#2a2a2a]/85">
                {policy}
              </p>
            </div>
          ))}
        </div>

        <p className="text-sm text-[#3a3a3a]/70 mt-6">
          * Detailed governance policies and committee documents will be
          updated periodically.
        </p>
      </section> */}
    </InnerLayout>
  );
};

export default Governance;